import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { IAppointment, IGoal, IService } from "interfaces";
import { PairValue } from "types";
import { Custom, Item, Modal, Progress } from "components";
import { Box, Grid, Typography } from "@mui/material";
import { Constants, Helpers } from "utils";

import * as Icon from "assets/icons";

type Props = {};

export const QubePlus = (props: Props) => {
  const { t, theme, service } = useApp();

  const [healthGoalsOpened, setHealthGoalsOpened] = useState(false);
  const [health360JourneyOpened, setHealth360JourneyOpened] = useState(false);
  const [healthPlanOpened, setHealthPlanOpened] = useState(false);

  const customLabel = (label: string) => (
    <div className={"cinzel"} style={{ fontSize: "1.5rem" }}>
      <b style={{ fontFamily: "inherit" }}>My </b>
      {label}
    </div>
  );

  return (
    <>
      <Custom.Card
        title={"QUBE+"}
        // titleSx={{ color: "#fff" }}
        // sx={{ backgroundColor: theme.color.primary.color }}
        action={
          <>
            <Custom.Button
              size="small"
              variant="contained"
              onClick={() => setHealthGoalsOpened(true)}
              sx={{
                padding: "0.5rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              {"My Health Goals"}
            </Custom.Button>
            <Modal.HealthGoal
              opened={healthGoalsOpened}
              onClose={() => setHealthGoalsOpened(false)}
            />
          </>
        }
      >
        <div
          style={{
            width: "min(100%, 1200px)",
            margin: "auto",
            paddingBottom: "2rem",
          }}
        >
          <Custom.Carousel
            actions={[
              () => setHealthGoalsOpened(true),
              () => setHealth360JourneyOpened(true),
              () => setHealthPlanOpened(true),
            ]}
          />
        </div>

        <Box sx={{ position: "relative" }}>
          <Grid container spacing={theme.margin.md}>
            <Grid item xs={6} sm={3} md>
              <Box
                component="div"
                className="qh-item qh-service"
                onClick={() => setHealth360JourneyOpened(true)}
                sx={{ backgroundColor: theme.palette.background.color }}
              >
                <div className="wrapper">
                  <Icon.Health360
                    style={{
                      width: "75%",
                      height: "75%",
                    }}
                  />

                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.md,
                      color: theme.palette.font.color,
                    }}
                  >
                    {customLabel("Health 360")}
                  </Typography>
                </div>
              </Box>
            </Grid>

            <Grid item xs={6} sm={3} md>
              <Box
                component="div"
                className="qh-item qh-service"
                onClick={() => setHealthPlanOpened(true)}
                sx={{ backgroundColor: theme.palette.background.color }}
              >
                <div className="wrapper">
                  <Icon.HealthPlan
                    style={{
                      width: "75%",
                      height: "75%",
                    }}
                  />
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.md,
                      color: theme.palette.font.color,
                    }}
                  >
                    {customLabel("Health Plan")}
                  </Typography>
                </div>
              </Box>
            </Grid>

            <Grid item xs={6} sm={3} md>
              <Box
                component="div"
                className="qh-item qh-service"
                onClick={() => {}}
                sx={{ backgroundColor: theme.palette.background.color }}
              >
                <div className="wrapper">
                  {/* Icon */}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.md,
                      color: theme.palette.font.color,
                    }}
                  >
                    <div className="cinzel">{"My Health Team"}</div>
                  </Typography>
                </div>
              </Box>
            </Grid>

            <Grid item xs={6} sm={3} md>
              <Box
                component="div"
                className="qh-item qh-service"
                onClick={() => {}}
                sx={{ backgroundColor: theme.palette.background.color }}
              >
                <div className="wrapper">
                  {/* Icon */}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.md,
                      color: theme.palette.font.color,
                    }}
                  >
                    <div className="cinzel">{"My Community"}</div>
                  </Typography>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Custom.Card>
      <Modal.Health360Scores
        opened={health360JourneyOpened}
        onClose={() => setHealth360JourneyOpened(false)}
      />
      <Modal.HealthPlan
        opened={healthPlanOpened}
        onClose={() => setHealthPlanOpened(false)}
      />
    </>
  );
};
